// The order of the Results page's lists (pages/admin/Events). The server sends
// a meet's events in the club's own event type order (Club Settings, Event
// Types), and that order is kept for the event filter and the table, in the
// event view and the age view alike. Within an event the groups go in number
// order ("U10", "10", "Y5" and a combined "14-17" are read by their first
// number), named groups such as "Open" after them; rows that tie keep the
// server's order (boys and girls). docs/school-carnivals-step-3-relays.md,
// 11.6, items 5 and 6.

const groupNumber = (name) => {
  const match = /\d+/.exec(String(name ?? ''));
  return match ? Number(match[0]) : Infinity;
};

export const compareGroups = (a, b) => {
  const aNumber = groupNumber(a);
  const bNumber = groupNumber(b);
  if (aNumber !== bNumber) return aNumber < bNumber ? -1 : 1;
  return String(a ?? '').localeCompare(String(b ?? ''));
};

// rows: the table's rows, as the server listed them; eventTypeValue is the
// event's name and ageGroup its group.
export const inServerEventOrder = (rows) => {
  const place = new Map();
  rows.forEach((row) => {
    if (!place.has(row.eventTypeValue)) place.set(row.eventTypeValue, place.size);
  });
  return [...rows].sort(
    (a, b) =>
      place.get(a.eventTypeValue) - place.get(b.eventTypeValue) ||
      compareGroups(a.ageGroup, b.ageGroup)
  );
};

// The event filter's choices: each event once, in the rows' order.
export const eventNamesInOrder = (rows) => [
  ...new Set(rows.map((row) => row.eventTypeValue).filter(Boolean)),
];
